
    <app-circle-btn edit (btnClicked)="btnEvent()">
      <app-edit-icon></app-edit-icon>
    </app-circle-btn>
  